import React, { Component } from "react";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import { WHATSAPP_MEDIA_GALLERY } from "../../../constants/ServiceConstants";
import api from "../../../axios/Axios";
import Title from "../../UI/Text/Title";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Alert from "../../UI/Alert/Alert";
import Card from "../../UI/Card/Card";
import { HOST_URL } from "../api/Api";
import CopyMediaURL from "../../UI/Table/compopents/cell/CopyMediaURL";
import Axios from "../../../axios/Axios";
import DeleteModal from "../campaign/Rcs/DeleteModal";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackward, faForward } from "@fortawesome/free-solid-svg-icons";
import MediaSelector from "./MediaSelector";
import Spining from "../../UI/Spining/Spining";
import { handleUserLog } from "../../Utils/Utils";

class WhatsAppGallery extends Component {
  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;
    super();

    this.state = {
      userId: user_id,
      token: token,
      mediaName: "",
      mediaType: "",
      image_url: "",
      isError: false,
      errorMessage: "",
      messageType: "",
      setIsLoading: true,
      WhatsappMediaGalleryList: null,
      ErrorResponse: "",
      showDeletePopup: false,
      selectAllCheckbox: false,
      currentPage: 1,
      recordsPerPage: 10,
      currentRecords: [],
      totalPage: 0,
      whatsappMediaList: [],
      showMediaModal: false,
      selectedMedia: null,
      mediaOptionSelected: "image",
      deleteID: "",
      deleteURl: "",
      disable: false,
    };
    this.fileChangedHandler = this.fileChangedHandler.bind(this);
    // this.handleSelectAllCheckbox = this.handleSelectAllCheckbox.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }
  handleMediaSelect = (url) => {
    this.setState({ selectedMedia: url, showMediaModal: false });
  };

  componentDidMount() {
    this.getWhatsaAppMediaGallery();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.recordsPerPage !== this.state.recordsPerPage ||
      prevState.currentPage !== this.state.currentPage
    ) {
      this.getWhatsaAppMediaGallery();
    }
  }

  handleCheckboxChange = (e, row, selectAll) => {
    const isChecked = e.target.checked;
    if (selectAll) {
      this.setState({ selectAllCheckbox: isChecked })
    }
    this.setState((prevState) => ({
      WhatsappMediaGalleryList: prevState.WhatsappMediaGalleryList.map((item) => {
        if (selectAll) {
          return { ...item, checkBox: isChecked };
        } else if (item.id === row.id) {
          return { ...item, checkBox: isChecked };
        }
        return item;
      }),
    }));

  };



  replaceUrl = (url) => {
    var baseURL = document.location;
    return url?.replace("https://console.authkey.io/", `${baseURL.origin}/`);
  };

  getWhatsaAppMediaGallery = async () => {
    this.setState({ setIsLoading: true });
    try {
      const { data } = await api.post(WHATSAPP_MEDIA_GALLERY, {
        token: this.state.token,
        user_id: this.state.userId,
        method: "retrieve",
      });

      if (data.success === true) {
        this.filterJSONData(data.data);
        this.setState({ setIsLoading: false });
      } else {
        this.setState({ ErrorResponse: data, setIsLoading: false });
      }
    } catch (err) {
      console.log(err);
    }
  };

  filterJSONData = async (data) => {
    let Data = [];

    try {
      data.map((item) => {
        let FilterData = {};
        for (let key in item) {
          if (
            key === "id" ||
            key === "doc_type" ||
            key === "doc_name" ||
            key === "created" ||
            key === "doc_url" ||
            key === "status"
          ) {
            FilterData[key] = item[key];
          }
        }
        Data.push(FilterData);
      });
    } catch (err) {
      console.log(err);
    }

    // Preserve existing checkbox states if available
    const existingData = this.state.whatsappMediaList || [];

    const newData = Data.map((item) => {
      const existingItem = existingData.find((e) => e.id === item.id);
      return {
        ...item,
        checkBox: existingItem ? existingItem.checkBox : false,
      };
    });

    const indexOfLastRecord = this.state.currentPage * this.state.recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - this.state.recordsPerPage;
    const currentRecords = newData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(newData.length / this.state.recordsPerPage);

    this.setState({
      whatsappMediaList: newData,
      WhatsappMediaGalleryList: currentRecords,
      totalPage: totalPages,
    });
  };


  mediaHandlar = (e) => {
    this.setState({ mediaType: e.target.value });
  };

  uploadWhatsAppMedia() {
    this.setState({ isError: false , disable: true });
    let fileSize = this.state.image_url.size / (1024 * 1024);
    if (this.state.mediaType === "image") {
      if (fileSize > 30) {
        this.setState({
          isError: true,
          errorMessage: "Image should be less than 30MB",
          messageType: "alert-danger",
        });
        this.setState({disable: false});
        return;
      }
    }
    if (this.state.mediaType === "video") {
      if (fileSize > 30) {
        this.setState({
          isError: true,
          errorMessage: "Video should be less than 30MB",
          messageType: "alert-danger",
        });
        this.setState({disable: false});
        return;
      }
    }

    if (this.state.mediaType === "doc") {
      if (fileSize > 30) {
        this.setState({
          isError: true,
          errorMessage: "Document should be less than 30MB",
          messageType: "alert-danger",
        });
        this.setState({disable: false});
        return;
      }
    }

    const data = new FormData();
    data.append("amdfile", this.state.image_url);
    data.append("doc_name", this.state.mediaName);
    data.append("doc_type", this.state.mediaType);
    data.append("user_id", this.state.userId);
    data.append("token", this.state.token);
    data.append("method", "create");
    fetch(`${HOST_URL}/uploadFileWhatsapp.php`, {
      method: "POST",
      body: data,
    }).then((result) => {
      result.json().then((resp) => {

        if (resp.success === true) {
          this.setState({
            isError: true,
            errorMessage: resp.message,
            messageType: "alert-success",
          });
          this.setState({disable: false});
          handleUserLog("", "clicked_upload_media_button", "whatsapp_media_gallery", resp.message, "whatsapp_media_gallery", "", { mediaName: this.state.mediaName, mediaType: this.state.mediaType })
          this.getWhatsaAppMediaGallery();
        } else {
          this.setState({
            isError: true,
            errorMessage: resp.message,
            messageType: "alert-danger",
          });
          this.setState({disable: false})
          handleUserLog("", "clicked_upload_media_button", "whatsapp_media_gallery", resp.message, "whatsapp_media_gallery", "", { mediaName: this.state.mediaName, mediaType: this.state.mediaType })
        }
      });
    });
  }

  // fileChangedHandler(e) {
  //   if (e.target.files[0]) {
  //     this.setState({ image_url: e.target.files[0] });
  //   }
  // }

  fileChangedHandler(e) {
    const file = e.target.files[0];
    const { mediaType } = this.state;

    if (!file) return;

    const fileType = file.type;

    const allowedTypes = {
      image: [
        "image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif",
        "image/bmp", "image/tiff", "image/svg+xml", "image/x-icon",
        "image/heif", "image/heic"
      ],
      video: [
        "video/mp4", "video/mpeg", "video/quicktime", "video/x-msvideo",
        "video/x-ms-wmv", "video/3gpp", "video/3gpp2", "video/webm", "video/ogg"
      ],
      doc: [
        "application/pdf", "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "text/plain", "application/rtf", "application/vnd.oasis.opendocument.text",
        "application/x-iwork-pages-sffpages",
        "application/x-iwork-keynote-sffkey",
        "application/x-iwork-numbers-sffnumbers"
      ]
    };

    if (mediaType && !allowedTypes[mediaType].includes(fileType)) {
      this.setState({
        isError: true,
        errorMessage: `Invalid file type for selected "${mediaType}". Please upload a valid ${mediaType} file.`,
        messageType: "alert-danger",
        image_url: null,
      });
      e.target.value = "";
      return;
    }

    this.setState({
      image_url: file,
      isError: false,
      errorMessage: "",
    });
  }


  deleteMultiple = async () => {
    this.setState({setIsLoading : true});
    let selectedItems = this.state.WhatsappMediaGalleryList?.filter(x => x.checkBox);

    let selectedIDs = selectedItems?.map(x => x.id);
    let selectedURLs = selectedItems?.map(x => x.doc_url);


    try {
      let paramData = {
        user_id: this.state.userId,
        token: this.state.token,
        method: "delete_multiple",
        ids: selectedIDs,
        file_urls: selectedURLs
      }
      let { data } = await Axios.post(`${HOST_URL}/uploadFileWhatsapp.php`, paramData)
      if (data.success) {
        this.setState({
          isError: true,
          errorMessage: data.message,
          messageType: "alert alert-success",
        });
        this.setState({ showDeletePopup: false });
        handleUserLog("", "clicked_delete_multiple_button", "whatsapp_media_gallery", data.message, "whatsapp_media_gallery", "", { ids: selectedIDs })
        this.getWhatsaAppMediaGallery();
      }
      else {
        this.setState({
          isError: true,
          errorMessage: data.message,
          messageType: "alert alert-danger",
        });
        this.setState({ showDeletePopup: false });
        handleUserLog("", "clicked_delete_multiple_button", "whatsapp_media_gallery", data.message, "whatsapp_media_gallery", "", { ids: selectedIDs })
      }
    } catch (error) {
      this.setState({
        isError: true,
        errorMessage: error.message,
        messageType: "alert alert-danger",
      });
      handleUserLog("", "clicked_delete_multiple_button", "whatsapp_media_gallery", error.message, "whatsapp_media_gallery", "", { ids: selectedIDs })
    }
    finally{
      this.setState({setIsLoading : false});
    }
  }

  handleNext = () => {
    if (this.state.currentPage < Math.ceil(this.state.whatsappMediaList.length / this.state.recordsPerPage)) {
      this.setState({ currentPage: this.state.currentPage + 1 });
    }
  };

  handlePrev = () => {
    if (this.state.currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1 });
    }
  };

  // MEDIA_GALLERY = [
  //   {
  //     name: (
  //       <input
  //         type="checkbox"
  //         checked={this?.state?.selectAllCheckbox}
  //         onChange={(e) => this.handleCheckboxChange(e, null, true)}
  //         className="media-checkbox"
  //       />
  //     ),
  //     cell: (row) => <input type="checkbox" checked={row.checkBox} className="media-checkbox" onChange={(e) => this.handleCheckboxChange(e, row, false)} />,
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     width: '60px',
  //   },
  //   {
  //     name: "id",
  //     selector: (row) => row.id,
  //     sortable: true,
  //     width: "80px",
  //   },
  //   {
  //     name: "Media Type",
  //     cell: (row) => <strong className="text-primary"> {row.doc_type}</strong>,
  //     selector: (row) => row.doc_type,
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Media Name",
  //     selector: (row) => row.doc_name,
  //     sortable: true,
  //     width: "300px",
  //   },
  //   {
  //     name: "Media URL",
  //     cell: (row) => (
  //       row.doc_type.includes("image") || row.doc_type.includes("png") ? <img className="mediaGallery_images" src={`${this.replaceUrl(row.doc_url)}`} alt="Image Preview" /> :
  //         row.doc_type.includes("video") ? (
  //           <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/711/711245.png" alt="Video Preview" />
  //         )
  //           : row.doc_type.includes("file") ? (
  //             <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/201/201153.png" />
  //           )
  //             : row.doc_type.includes("pdf") ? (
  //               <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/201/201153.png" />
  //             )
  //               : row.doc_type.includes("\/etc\/passwd") ? (
  //                 <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/9775/9775639.png" />
  //               )
  //                 : row.doc_type.includes("file:\/\/\/etc\/passwd") ? (
  //                   <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/9775/9775639.png" />
  //                 )
  //                   : row.doc_type.includes("doc") ? (
  //                     <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/2258/2258853.png" />
  //                   )
  //                     : row.doc_type.includes("audio\/mpeg") ? (
  //                       <img
  //                         className="mediaGallery_images"
  //                         src="https://cdn-icons-png.flaticon.com/128/8300/8300731.png"
  //                         alt="Audio Preview"
  //                       />
  //                     )
  //                       : row.doc_type.includes("mp4") ? (
  //                         <img
  //                           className="mediaGallery_images"
  //                           src="https://cdn-icons-png.flaticon.com/128/8300/8300728.png"
  //                           alt="Audio Preview"
  //                         />
  //                       )
  //                         : row.doc_type.includes("audio\/...\/mpeg") ? (
  //                           <img
  //                             className="mediaGallery_images"
  //                             src="https://cdn-icons-png.flaticon.com/128/8300/8300731.png"
  //                             alt="Audio Preview"
  //                           />
  //                         )
  //                           : row.doc_type.includes("audio\/wav") ? (
  //                             <img
  //                               className="mediaGallery_images"
  //                               src="https://cdn-icons-png.flaticon.com/128/2031/2031975.png"
  //                               alt="Audio Preview"
  //                             />
  //                           ) :
  //                             <a href={`${this.replaceUrl(row.doc_url)}`}> {this.replaceUrl(row.doc_url)} </a>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "Action",
  //     cell: (e) => <CopyMediaURL id={e.id} url={`${this.replaceUrl(e.doc_url)}`} />,
  //     width: "200px",
  //   },
  // ];

  deletePopup = (id, url) => {
    this.setState({ deleteID: id, showDeletePopup: true, deleteURl: url })
  }

  Delete = async () => {
    let data = {
      user_id: this.state.userId,
      method: "delete",
      token: this.state.token,
      id: this.state.deleteID,
      file_url: this.state.deleteURl
    }
    try {
      let response = await fetch(`${HOST_URL}/uploadFileWhatsapp.php`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      let result = await response.json();
      if (result.success) {
       handleUserLog("", "clicked_delete_multiple_button", "whatsapp_media_gallery", result.message, "whatsapp_media_gallery", "", { id: this.state.deleteID })
       this.getWhatsaAppMediaGallery();
       this.setState({showDeletePopup: false})
      }
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const { showMediaSelector, selectedMedia, mediaOptionSelected } = this.state;
    return (
      <DashboardLayout>
        <main className="content">
          <div className="container-fluid p-0">
            <Title isButton={false}> WhatsApp Media Gallery </Title>
            {this.state.isError && (
              <Alert type={this.state.messageType}>
                {this.state.errorMessage}
              </Alert>
            )}

            {this.state.setIsLoading && <Spining/>}

            <Card CardTitle="Update New Media">
              <div className="row">
                <div className="col-sm-4">
                  <label for="colFormLabel" className="col-form-label">
                    Media Type{" "}
                  </label>
                  <div className="">
                    <div className="input-group drop-down-icons  mb-2">
                      <select
                        className="form-control"
                        onChange={this.mediaHandlar}
                      >
                        <option value={``}>Choose Media Type</option>
                        <option value={`image`}>Image</option>
                        <option value={`video`}>Video</option>
                        <option value={`doc`}>Doc type</option>
                      </select>
                    </div>
                    <small className="text-danger" style={{ fontSize: "11px" }}>
                      <strong>* Note:</strong>
                      <ul>
                        <li style={{ fontSize: "11px" }}>Images should be smaller than 5MB.</li>
                        <li style={{ fontSize: "11px" }}>Upload an MP4 video with 720p resolution (1280×720), max 16MB, for best quality.</li>
                        <li style={{ fontSize: "11px" }}>PDF and DOC files should be smaller than 30MB.</li>
                      </ul>
                    </small>
                  </div>
                </div>

                <div className="col-sm-4">
                  <label for="colFormLabel" className="col-form-label">
                    Media Name{" "}
                  </label>
                  <div className="">
                    <div className="input-group mb-2">
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                          this.setState({ mediaName: e.target.value })
                        }
                        id="inlineFormInputGroup"
                        placeholder="Media File Name"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <label for="colFormLabel" className="col-form-label">
                    Select Media File{" "}
                  </label>
                  <div className="">
                    <div className="input-group mb-2">
                      <input
                        type="file"
                        onChange={this.fileChangedHandler}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* <div className="col-4">
                    <input type="checkbox" checked={this.state.selectAllCheckbox} className="media-checkbox ml-3 mt-2" onChange={(e) => this.handleCheckboxChange(e, null, true)} />
                    <span className="ml-1">Select All</span>
                  </div> */}
                  <div className="col-sm-12 d-flex align-items-end">
                    <button
                      type="button"
                      onClick={() => this.uploadWhatsAppMedia()}
                      className="btn mt-2 btn-blue btn-sm ml-auto "
                      disabled={this.state.disable ? true : false}
                    >
                      {" "}
                      Upload Media
                    </button>



                    <button
                      className="btn mt-2 btn-blue btn-sm"
                      onClick={() => {
                        handleUserLog("", "clicked_view_media_gallery_button", "whatsapp_media_gallery", "User click on View Media Gallery button", "whatsapp_media_gallery", "", "");
                        this.setState({ showMediaModal: true });
                      }}
                    >
                      View Media Gallery
                    </button>

                    <MediaSelector
                      isOpen={this.state.showMediaModal}
                      onClose={() => this.setState({ showMediaModal: false })}
                      selectedMedia={this.state.selectedMedia}
                      onSelectMedia={this.handleMediaSelect}
                      userId="1234"
                      token="abc123"
                      mediaOptionSelected={this.state.mediaOptionSelected}
                      setMediaOptionSelected={(val) =>
                        this.setState({ mediaOptionSelected: val })
                      }
                      gotoMediaPage={() =>
                        (window.location.href = "/dashboard/whatsapp-gallery")
                      }
                    />

                    {this.state.WhatsappMediaGalleryList?.filter(x => x.checkBox).length > 1 &&
                      <button
                        type="button"
                        onClick={() => {
                          handleUserLog("", "clicked_delete_multiple_button", "whatsapp_media_gallery", "User click on Delete Multiple button", "whatsapp_media_gallery", "", "");
                          this.setState({ showDeletePopup: true });
                        }}
                        className="btn mt-2 btn-danger btn-sm float-right"
                      >
                        {" "}
                        Delete Multiple
                      </button>}
                  </div>
                </div>

              </div>
            </Card>

            {/* <AdvanceDataTable
              // tableName={"WhatsApp Media URL List"}
              tableCell={this.MEDIA_GALLERY}
              tableData={this.state.WhatsappMediaGalleryList}
              isLoading={this.state.setIsLoading}
              isError={this.state.ErrorResponse}
              // pagination={true}
            /> */}


            {this.state.WhatsappMediaGalleryList?.length > 0 ?
              <div className="card">
                <div className="card-body">
                  <div style={{ height: '800px', overflowY: 'auto' }} className="table-responsive">
                    <table className="table table-hover align-middle table-striped border">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th style={{ color: "white", width: "40px" }}>
                            <input
                              type="checkbox"
                              checked={this?.state?.selectAllCheckbox}
                              onChange={(e) => this.handleCheckboxChange(e, null, true)}
                              className="media-checkbox"
                            />
                          </th>
                          <th style={{ color: "white", width: "60px" }}>ID</th>
                          <th style={{ color: "white", width: "120px" }}>Media Type</th>
                          <th style={{ color: "white", maxWidth: "120px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Media Name</th>
                          <th style={{ color: "white", maxWidth: "180px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Media URL</th>
                          <th style={{ color: "white", width: "80px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.WhatsappMediaGalleryList?.map((item, i) => (
                          <tr key={i}>
                            <td>
                              <input
                                type="checkbox"
                                checked={item.checkBox}
                                className="media-checkbox"
                                onChange={(e) => this.handleCheckboxChange(e, item, false)}
                              />
                            </td>
                            <td className="text-primary fw-bold text-end">{item.id}</td>
                            <td>
                              <strong className="text-primary">{item.doc_type}</strong>
                            </td>
                            <td style={{ maxWidth: "120px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {item.doc_name}
                            </td>
                            <td style={{ maxWidth: "180px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {item.doc_type.includes("image") || item.doc_type.includes("png") ? (
                                <img className="mediaGallery_images" src={this.replaceUrl(item.doc_url)} alt="Image Preview" />
                              ) : item.doc_type.includes("video") ? (
                                <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/711/711245.png" alt="Video Preview" />
                              ) : item.doc_type.includes("pdf") || item.doc_type.includes("file") ? (
                                <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/201/201153.png" alt="File Preview" />
                              ) : item.doc_type.includes("doc") ? (
                                <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/2258/2258853.png" alt="Doc Preview" />
                              ) : item.doc_type.includes("audio/mpeg") || item.doc_type.includes("audio/.../mpeg") ? (
                                <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/8300/8300731.png" alt="Audio Preview" />
                              ) : item.doc_type.includes("mp4") ? (
                                <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/8300/8300728.png" alt="Video Preview" />
                              ) : item.doc_type.includes("audio/wav") ? (
                                <img className="mediaGallery_images" src="https://cdn-icons-png.flaticon.com/128/2031/2031975.png" alt="Audio Preview" />
                              ) : (
                                <a href={this.replaceUrl(item.doc_url)} target="_blank" rel="noopener noreferrer">
                                  {this.replaceUrl(item.doc_url)}
                                </a>
                              )}
                            </td>
                            <td>
                              <CopyMediaURL id={item.id} url={this.replaceUrl(item.doc_url)} />
                              <span onClick={() => {
                                handleUserLog("", "clicked_delete_multiple_button", "whatsapp_media_gallery", "User click on delete media button", "whatsapp_media_gallery", "", { id: item.id });
                                this.deletePopup(item.id, item.doc_url);
                              }} className="badge bg-danger mr-2">Delete</span>{" "}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="row mt-3 mr-3">
                    <div className="col-sm-12 d-flex justify-content-end align-items-center">
                      <span style={{ fontSize: "13px" }}>Rows Per Page:</span>
                      <select
                        value={this.state.recordsPerPage}
                        className="ml-2"
                        onChange={(e) =>
                          this.setState({ recordsPerPage: parseInt(e.target.value) })
                        }
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ml-4" style={{ fontSize: "13px" }}>
                        {this.state.currentPage} - {this.state.totalPage}
                      </span>
                      <span style={{ fontSize: "13px" }}>
                        <FontAwesomeIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleUserLog("", "prev_page_button", "whatsapp_media_gallery", "User click on Previous page button", "whatsapp_media_gallery", "", { page: this.state.currentPage });
                            this.handlePrev();
                          }}
                          className="ml-4"
                          icon={faBackward}
                        />
                      </span>
                      <span style={{ fontSize: "13px" }}>
                        <FontAwesomeIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleUserLog("", "next_page_button", "whatsapp_media_gallery", "User click on Next page button", "whatsapp_media_gallery", "", { page: this.state.currentPage });
                            this.handleNext();
                          }}
                          className="ml-4"
                          icon={faForward}
                        />
                      </span>
                    </div>
                  </div>

                </div>
              </div> :
              <div className="text-center">
                <div className="card-body">
                  <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                  <p> No Any Record Found </p>
                </div>
              </div>}
            <DeleteModal show={this.state.showDeletePopup} onClose={() => this.setState({ showDeletePopup: false })} onDelete={this.state.deleteID ? this.Delete : this.deleteMultiple} />
          </div>
        </main>
      </DashboardLayout>
    );
  }
}

export default WhatsAppGallery;
